<template>
  <div v-if="show" class="modal__wrap">
    <a-modal
      width="50vw"
      :visible="show"
      :title="null"
      :footer="null"
      :mask="false"
      :closable="false"
      transitionName="none"
      maskTransitionName="none"
      @cancel="$emit('closeModal')"
    >
      <div class="modal__table">
        <btn-export
          v-if="showExportBtn"
          :config="config"
          :columns="exportHeader"
          :data="data"
          btnText="Выгрузить"
        />
        <div
          :class="[
            'modal__header',
            type === 'general' ? 'modal__header_general' : 'modal__header_child',
          ]"
        >
          <div v-for="title in columns" :key="title" class="modal__header_title">
            {{ title }}
          </div>
        </div>
        <div
          v-for="(item, index) in data"
          :key="index"
          :class="['modal__row', type === 'general' ? 'modal__row_general' : 'modal__row_child']"
        >
          <template v-if="type === 'general'">
            <div class="modal__content">
              {{ item.value.translate_name }}
            </div>

            <div class="modal__content-general">
              <div
                v-for="(infoValue, infoTitle, infoIndex) in item.value.info"
                :key="infoIndex"
                class="modal__inside-content-general"
                style="width: 100%"
              >
                <div class="modal__general-content">
                  {{ infoTitle }}
                </div>

                <div class="modal__general-content"  style="overflow-x: scroll;">
                  {{ infoValue }}
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="modal__content">
              {{ item.name }}
            </div>

            <div class="modal__content">
              {{ item.value }}
            </div>
          </template>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'ComponentCustomModal',

  components: {
    BtnExport: () => import('@/components/base/BtnExport.vue'),
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    showExportBtn: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columnsForGeneral: ['Процесс', 'Заголовок', 'Значение'],
      columnsForChild: ['Заголовок', 'Значение'],
    };
  },

  computed: {
    columns() {
      return this.type === 'general' ? this.columnsForGeneral : this.columnsForChild;
    },
    exportHeader() {
      return this.columns.map((el) => ({
        title: el,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  &__wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 5;
    background-color: rgba(0, 0, 0, 0.3);
  }

  &__table {
    width: 100%;
    padding: 48px 12px 12px 12px;
  }

  &__header {
    display: grid;
    background-color: $colorBoxTable;
    border: 1px solid darken($color: white, $amount: 15%);

    &_general {
      grid-template-columns: repeat(3, 1fr);
    }

    &_child {
      grid-template-columns: repeat(2, 1fr);
    }

    &_title {
      padding: 8px 4px;
      font-size: 16px;
      font-weight: 500;
      border-right: 1px solid darken($color: white, $amount: 15%);

      &:last-child {
        border-right: none;
      }
    }
  }

  &__row {
    display: grid;
    border-left: 1px solid darken($color: white, $amount: 15%);
    border-right: 1px solid darken($color: white, $amount: 15%);
    border-bottom: 1px solid darken($color: white, $amount: 15%);

    &_general {
      grid-template-columns: 1fr 2fr;
    }

    &_child {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__content-general {
    display: grid;
    align-self: stretch;
  }

  &__inside-content-general {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: row;
    border-bottom: 1px solid darken($color: white, $amount: 15%);

    &:last-child {
      border-bottom: none;
    }
  }

  &__general-content {
    padding: 8px 4px;
    font-size: 12px;
    font-weight: 500;
    border-right: 1px solid darken($color: white, $amount: 15%);

    &:last-child {
      border-right: none;
    }
  }

  &__content {
    padding: 8px 4px;
    font-size: 12px;
    font-weight: 500;
    border-right: 1px solid darken($color: white, $amount: 15%);
    align-self: stretch;

    &:last-child {
      border-right: none;
    }
  }
}
</style>
